export class OrganizationGroupAccess {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "idpName",
            "baseName": "idpName",
            "type": "string",
            "format": ""
        },
        {
            "name": "groupName",
            "baseName": "groupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "roles",
            "baseName": "roles",
            "type": "Array<RoleSummary>",
            "format": ""
        },
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<IdpGroupUser>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OrganizationGroupAccess.attributeTypeMap;
    }
    constructor() {
    }
}
